import { render, staticRenderFns } from "./ActivityItemStaticField.vue?vue&type=template&id=13c80302"
import script from "./ActivityItemStaticField.vue?vue&type=script&lang=js"
export * from "./ActivityItemStaticField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports